function initProductGallery(container) {
  if (container.classList.contains('is-swiper-initialized')) return;

  const mainSwiperEl = container.querySelector('.main-swiper');
  const thumbSwiperEl = container.querySelector('.thumbnail-swiper');
  const nextEl = container.querySelector('.swiper-button-next');
  const prevEl = container.querySelector('.swiper-button-prev');

  if (!mainSwiperEl || !thumbSwiperEl) return;

  const direction = window.innerWidth >= 1024 ? 'vertical' : 'horizontal';

  // Thumbnail Swiper
  const thumbnailSwiper = new Swiper(thumbSwiperEl, {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    loop: true,
    direction,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
    breakpoints: {
      320: { slidesPerView: 3, direction: 'horizontal' },
      640: { slidesPerView: 4, direction: 'horizontal' },
      1024: { slidesPerView: 4, direction: 'vertical' },
    },
  });

  // Main Swiper
  const mainSwiper = new Swiper(mainSwiperEl, {
    spaceBetween: 10,
    navigation: { nextEl, prevEl },
    thumbs: { swiper: thumbnailSwiper },
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
    loop: true,
    grabCursor: true,
    keyboard: { enabled: true },
    mousewheel: { forceToAxis: true },
    on: {
      init: () => {
        container.classList.add('isInitialize');
      },
    },
  });

  container._mainSwiper = mainSwiper;
  container._thumbnailSwiper = thumbnailSwiper;
  container.classList.add('is-swiper-initialized');

  container.addEventListener('media-changed', (event) => {
    const variant = event.detail.variant;
    const sku = variant?.sku;
    if (sku) filterSlidesBySKU(container, sku);
  });
}

function destroyProductGallery(container) {
  const mainSwiper = container._mainSwiper;
  const thumbSwiper = container._thumbnailSwiper;

  if (mainSwiper) {
    mainSwiper.destroy(true, true);
    container._mainSwiper = null;
  }
  if (thumbSwiper) {
    thumbSwiper.destroy(true, true);
    container._thumbnailSwiper = null;
  }

  container.classList.remove('isInitialize', 'is-swiper-initialized');
}

function filterSlidesBySKU(container, sku) {
  if (!sku) return;

  const normalizedSKU = sku.trim().toLowerCase();
  const slides = container.querySelectorAll('.main-swiper .product__media-item');
  const thumbSlides = container.querySelectorAll('.thumbnail-swiper .thumbnail-list__item');

  if (container._mainSwiper || container._thumbnailSwiper) {
    destroyProductGallery(container);
  }

  let hasMatchingSlides = false;

  slides.forEach((slide) => {
    const alt = slide.getAttribute('data-alt');
    const title = slide.getAttribute('data-product-title');
    const normalizedAlt = alt?.trim().toLowerCase();
    const match = normalizedAlt === normalizedSKU || alt === title;

    if (match) {
      slide.style.display = 'block';
      slide.classList.add('swiper-slide');
      hasMatchingSlides = true;
    } else {
      slide.style.display = 'none';
      slide.classList.remove('swiper-slide');
    }
  });

  thumbSlides.forEach((thumb) => {
    const alt = thumb.getAttribute('data-alt');
    const title = thumb.getAttribute('data-product-title');
    const normalizedAlt = alt?.trim().toLowerCase();
    const match = normalizedAlt === normalizedSKU || alt === title;

    if (match) {
      thumb.style.display = 'flex';
      thumb.classList.add('swiper-slide');
    } else {
      thumb.style.display = 'none';
      thumb.classList.remove('swiper-slide');
    }
  });

  if (hasMatchingSlides) {
    requestIdleCallback(() => initProductGallery(container));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.product__media-wrapper');
  if (!gallery) return;

  const firstVariantSKU = gallery.getAttribute('data-variant-sku');

  requestIdleCallback(() => {
    initProductGallery(gallery);

    if (firstVariantSKU) {
      filterSlidesBySKU(gallery, firstVariantSKU);
    } else {
      gallery.classList.add('isInitialize');
    }
  });

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const direction = window.innerWidth >= 1024 ? 'vertical' : 'horizontal';
      const thumbSwiper = gallery._thumbnailSwiper;

      if (thumbSwiper && thumbSwiper.params.direction !== direction) {
        thumbSwiper.changeDirection(direction);
      }
    }, 500);
  });
});
